<div class="row">
  <div class="col-md-4"></div>

  <div class="col-md-4">
    <div class="row bloque-simple">
      <div class="col-md-12">

        <h3 class="card-title title"><b>Taxes</b></h3>
        <hr />

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating">Country</label>
              <select
                name="countryTax"
                [(ngModel)]="country"
                class="form-control fctrl"
                [disabled]="!edit"
              >
                <option value="USA">
                  USA
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating">State &nbsp; <i *ngIf="loading" class="fa fa-circle-o-notch fa-spin fa-fw"></i></label>
              <select
                name="countryTax"
                [(ngModel)]="state_tax"
                class="form-control fctrl"
                [disabled]="!edit"
              >
                <option [value]="null">
                  Select state
                </option>

                <option *ngFor="let state of states" [value]="state.id">
                  {{state.name}}: {{state.tax}}%
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-success btn-block btn-md" [disabled]="aplicando || state_tax === null || !edit" (click)="aplicar()">
              <i *ngIf="aplicando" class="fa fa-circle-o-notch fa-spin fa-fw"></i> Apply
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="col-md-4">
    <div class="row bloque-simple">
      <div class="col-md-12" style="text-align: right;">

        <button type="button" class="btn btn-outline-danger" (click)="borrar()" [disabled]="borrando || !aplicado">
          <i *ngIf="borrando" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          <span *ngIf="!borrando" class="material-icons">format_clear</span> Clear Tax
        </button>

      </div>
    </div>
  </div>
</div>
